import { useModal } from '@codecorp/components'
import { ReactNode } from 'react'

export const useShowModal = () => {
    const { show } = useModal() // Access the modal context
    const dialogClassName =
        'max-[640px]:w-4/5 sm:w-3/5  md:w-2/3 lg:w-1/4 xl:w-1/4 2xl:w-1/4'
    const showModal = (
        content: Exclude<ReactNode, null | undefined | boolean>
    ) => {
        show({
            content,
            modal: true,
            dialogClassName: dialogClassName,
        })
    }

    return showModal
}
